import Vue from 'vue';

export default Vue.component('SelectUpdate', {
    data() {
        return {
            select: null,
            selected: [],
        };
    },
    watch: {
        selected() {
            this.$emit('update', this.selected);
        },
    },
    methods: {
        changeUpdate() {
            const selectedItems = [].slice.call(this.select.selectedOptions);
            this.selected = selectedItems.map(function(element) {
                return element.value;
            });
        },
    },
    mounted() {
        this.select = this.$slots.default[0].elm;
        this.select.addEventListener('change', this.changeUpdate);
        this.changeUpdate();

    },
    beforeDestroy() {
        this.select.removeEventListener('change', this.changeUpdate);
    },
    template: `
        <div>
            <slot></slot>
        </div>
    `,
});
